import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Drawer/drawer';
import { css } from '@patternfly/react-styles';
export var DrawerPanelBody = function DrawerPanelBody(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      children = _a.children,
      _a$hasNoPadding = _a.hasNoPadding,
      hasNoPadding = _a$hasNoPadding === void 0 ? false : _a$hasNoPadding,
      props = __rest(_a, ["className", "children", "hasNoPadding"]);

  return React.createElement("div", Object.assign({
    className: css(styles.drawerBody, hasNoPadding && styles.modifiers.noPadding, className)
  }, props), children);
};